'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _DatePicker = require('./DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DatePicker = function DatePicker(_ref) {
  var _ref$input = _ref.input,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      className = _ref.className,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      restProps = _objectWithoutProperties(_ref, ['input', 'className', 'meta']);

  var momentValue = value ? (0, _moment2.default)(value) : null;
  return _react2.default.createElement(_DatePicker2.default, _extends({}, restProps, {
    value: momentValue,
    onChange: onChange,
    className: className,
    error: error && touched
  }));
};

DatePicker.propTypes = {
  className: _propTypes2.default.string,
  input: _propTypes2.default.shape({
    value: _propTypes2.default.objectOf(_moment2.default),
    onChange: _propTypes2.default.func.isRequired
  }).isRequired,
  meta: _propTypes2.default.shape({
    touched: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string
  }).isRequired
};

DatePicker.defaultProps = {
  className: ''
};

exports.default = DatePicker;
DatePicker.__docgenInfo = [{
  'description': '',
  'displayName': 'DatePicker',
  'methods': [],
  'props': {
    'className': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'input': {
      'type': {
        'name': 'shape',
        'value': {
          'value': {
            'name': 'objectOf',
            'value': {
              'name': 'custom',
              'raw': 'moment'
            },
            'required': false
          },
          'onChange': {
            'name': 'func',
            'required': true
          }
        }
      },
      'required': true,
      'description': ''
    },
    'meta': {
      'type': {
        'name': 'shape',
        'value': {
          'touched': {
            'name': 'bool',
            'required': true
          },
          'error': {
            'name': 'string',
            'required': false
          }
        }
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/DatePickers/datePicker-redux-form.js'] = {
    name: 'DatePicker',
    docgenInfo: DatePicker.__docgenInfo,
    path: 'src/DatePickers/datePicker-redux-form.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/DatePickers/datePicker-redux-form.js
// module id = 306
// module chunks = 1